import { render, staticRenderFns } from "./table-pagination.vue?vue&type=template&id=27a3cc98"
import script from "./table-pagination.ts?vue&type=script&lang=ts&external"
export * from "./table-pagination.ts?vue&type=script&lang=ts&external"
import style0 from "./table-pagination.scss?vue&type=style&index=0&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27a3cc98')) {
      api.createRecord('27a3cc98', component.options)
    } else {
      api.reload('27a3cc98', component.options)
    }
    module.hot.accept("./table-pagination.vue?vue&type=template&id=27a3cc98", function () {
      api.rerender('27a3cc98', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/table/table-pagination/table-pagination.vue"
export default component.exports